import { ChevronRightIcon } from "@chakra-ui/icons";
import { Menu, MenuButton, MenuItem, MenuList } from "@chakra-ui/react";
import { useLocation } from "react-router-dom";
import { ThemeColor } from "../../theme/palette";
import { headerMenuItemProps, headerMenuListProps } from "./HeaderDropdown";

export const HeaderMoreMenu = () => {
  const location = useLocation();

  return (
    <Menu placement="bottom-start">
      <MenuButton
        className={location.pathname === "/kyros" ? "active nav-link" : "nav-link"}
        color="white"
        _hover={{ color: ThemeColor.KAIROS }}
      >
        More <ChevronRightIcon />
      </MenuButton>
      <MenuList {...headerMenuListProps}>
        <MenuItem
          as="a"
          href="https://docs.kyros.fi/"
          target="_blank"
          rel="noopener noreferrer"
          {...headerMenuItemProps}
        >
          Docs
        </MenuItem>
        <MenuItem
          as="a"
          href="https://www.metadao.fi/projects/kyros"
          target="_blank"
          rel="noopener noreferrer"
          {...headerMenuItemProps}
        >
          DAO
        </MenuItem>
        <MenuItem as="a" href="/kyros" {...headerMenuItemProps}>
          $KYROS
        </MenuItem>
      </MenuList>
    </Menu>
  );
};
